import React from "react";
import { useFormContext } from "react-hook-form";
import { InputLabel } from "./InputLabel";
import { InputErrorMessage } from "components/atoms";

export interface PaziaPrefixInputProps {
  name: string;
  prefix: string;
  type?: "number" | "text";
  label?: string;
  disabled?: boolean;
  placeholder?: string;
  step?: string;
  required?: boolean;
  className?: string;
}
export const PaziaPrefixInput = ({
  name,
  prefix,
  type = "text",
  label,
  step,
  placeholder,
  disabled, // TODO !!
  required,
  className = "",
}: PaziaPrefixInputProps): JSX.Element => {
  const { register } = useFormContext();
  return (
    <div className={className}>
      <InputLabel label={label} required={required} name={name} />
      <div className="relative">
        <input
          id={name}
          className={`form-input h-9 w-full pl-12 dark:bg-slate-800`}
          type={type}
          step={step}
          placeholder={placeholder}
          {...register(name)}
        />
        <div className="pointer-events-none absolute inset-0 right-auto flex items-center">
          <span className="px-3 text-sm font-medium text-slate-400 dark:text-slate-500">{prefix}</span>
        </div>
      </div>
      <InputErrorMessage name={name} />
    </div>
  );
};
